<template>
  <div style="height: 100%;width: 100%;float: right">
    <dialog-component
      :dialog-title="dialogTitle"
      :dialogVisible.sync="cabinetDialogFlag"
      :width="width"
      @dialogClose="divClose"
      append-to-boby
      center>
      <div slot="content">
        <el-table
          :data="form.tableData"
          height="60vh"
          border
          style="width: 92%;margin: 4%">
          <el-table-column
            label="机柜名称"
            align="center"
            prop="name">
          </el-table-column>
          <el-table-column
            label="实时功率 （KW）"
            align="right"
            prop="realTimePower">
            <template v-slot="{row: {realTimePower}}">
              {{ realTimePower }}
            </template>
          </el-table-column>
          <el-table-column
            label="额定功率（KW）"
            align="right"
            prop="ratedPower">
            <template v-slot="{row: {ratedPower}}">
              {{ ratedPower }}
            </template>
          </el-table-column>
          <el-table-column
            label="差值 （KW）"
            align="right"
            prop="difference">
            <template v-slot="{row: {difference}}">
              {{ difference }}
            </template>
          </el-table-column>
        </el-table>
        <el-row style="text-align: center;height: 5vh" v-if="form.tableData.length > 0">
          <el-pagination
            :current-page.sync="form.pageCurrent"
            :page-size.sync="form.pageSize"
            :total="form.dataTotal"
            @current-change="handleCurrentChange"
            background
            layout="prev, pager, next">
          </el-pagination>
        </el-row>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import DialogComponent from "@/components/DialogComponent";

export default {
  name: "cabinetInfoDialog",
  props: ['cabinetDialogFlag', 'cabinetList'],
  components: {
    DialogComponent
  },
  data() {
    return {
      dialogTitle: '机柜信息列表',
      width: '50%',
      form: {
        pageCurrent: 0,
        pageSize: 10,
        dataTotal: 0,
        tableData: []
      }
    }
  },
  mounted() {
    this.form.dataTotal = this.$props.cabinetList.length
    this.form.tableData=this.$props.cabinetList
  },
  watch: {
    cabinetList() {
      this.form.dataTotal = this.$props.cabinetList.length
      this.form.tableData=this.$props.cabinetList
      this.changePages()
    }
  },
  methods: {
    divClose() {
      this.$emit("openCabinetInfoDetail")
    },
    handleCurrentChange(val) {
      //当前为第几页时调用getData()显示第几页数据
      this.form.pageCurrent = val;
      this.changePages()
    },
    // 改变分页
    changePages() {
      let endPage = this.form.pageCurrent * this.form.pageSize
      let beginPage = (this.form.pageCurrent - 1) * this.form.pageSize
      this.form.tableData = []
      for( let i = beginPage; i < endPage; i++ ) {
        if (i >= this.form.dataTotal) {
          return
        }
        this.form.tableData.push(this.$props.cabinetList[i])
      }
    }
  }
}
</script>

<style scoped>

.title {
  display: inline;
  font-size: 1rem;
  font-weight: bold;
  margin: 5px;
}

.close-btn {
  float: right;
  margin-top: 5px;
  margin-right: 8px;
  font-weight: normal;
  color: #FFFFFF;
}

.close-btn:hover {
  cursor: pointer;
}

.title-line {
  width: 50px;
  height: 2px;
  display: inline-block;
  margin-bottom: 5px;
  border-radius: 15px;
}

.tierDiv {
  height: 50px;
  width: 100%;
  border-radius: 5px;
  margin-bottom: 5px;
  display: flex;
  justify-content: center;
  align-items: center
}

.tierDiv:hover {
  background-color: rgb(26, 107, 179) !important;
  cursor: pointer;
}

.asideRight {
  overflow: auto;
  width: 100%;
}

.upload-img {
  position: absolute;
  width: 80px;
  height: 80px;
  left: 0;
  top: 0;
}

.upload-img:hover + .delete-icon {
  display: block;
}

.delete-icon:hover {
  display: block;
}

.delete-icon {
  line-height: 80px;
  height: 80px;
  width: 80px;
  position: center;
  display: none;
}

::v-deep .el-drawer {
  background-color: rgb(11, 50, 82);
  border-radius: 0 8px 8px 0;
}

::v-deep .asideRight .el-drawer {
  background-color: rgb(11, 50, 82);
  border-radius: 8px 0 0 8px;
}

::v-deep .asideRight .el-drawer__wrapper {
  width: 20%;
  left: unset;
}

::v-deep .el-drawer__header {
  color: white;
}

::v-deep .el-drawer__body {
  overflow-y: auto;
}


</style>
